import { useMemo } from "react";

import { InsuranceFullStoryProps } from "utilities/full-story";
import { useUqualFullStoryTrackingProps } from "./useUqualFullStoryTrackingProps";

export const useInsuranceFullStoryTrackingProps = (): InsuranceFullStoryProps => {
  const uqualTrackingProps = useUqualFullStoryTrackingProps();

  return useMemo(
    () => ({
      email: uqualTrackingProps.email,
      sessionId: uqualTrackingProps.sessionId,
      dealId: uqualTrackingProps.dealId,
      prospectId: uqualTrackingProps.prospectId,
      encompassLoanGuid: uqualTrackingProps.encompassLoanGuid,
      encompassLoanNumber: uqualTrackingProps.encompassLoanNumber,
      nhDealApplicationId: uqualTrackingProps.nhDealApplicationId,
      loanPurpose: uqualTrackingProps.loanPurpose,
      milestone: uqualTrackingProps.milestone,
      wasLoAssigned: uqualTrackingProps.wasLoAssigned,
      borrowerRoleType: uqualTrackingProps.borrowerType,
    }),
    [uqualTrackingProps],
  );
};
